// A PÉNZÜGY jogai a felületen — a Bevétel és a Kiadás KÜLÖN védett jog (user-döntés). A kulcs-listák a közös
// `@atlas/shared` `FINANCE_PERMISSIONS`-ből jönnek (a BFF jog-kapui is onnan), tehát a fül-kapu és a szerver nem
// térhet el egymástól.
import { FINANCE_PERMISSIONS, hasAnyPermission } from '@atlas/shared';

import { usePermissions } from '@/lib/use-permissions';

export interface FinanceAccess {
  /** Bevétel: a Bevételek fül + a Bevétel-elemzés + a kezdőlap MRR-kártyája. */
  revenue: boolean;
  /** Kiadás: a Kiadások fül + a Kiadás-elemzés. */
  expenses: boolean;
  expensesManage: boolean;
  expensesDelete: boolean;
  /** Bármelyik — a lap és a menüpont kapuja. */
  any: boolean;
  isLoading: boolean;
}

export function useFinanceAccess(): FinanceAccess {
  const { can, isLoading } = usePermissions();
  const revenue = hasAnyPermission(FINANCE_PERMISSIONS.revenueView, can);
  const expenses = hasAnyPermission(FINANCE_PERMISSIONS.expensesView, can);
  return {
    revenue,
    expenses,
    expensesManage: hasAnyPermission(FINANCE_PERMISSIONS.expensesManage, can),
    expensesDelete: hasAnyPermission(FINANCE_PERMISSIONS.expensesDelete, can),
    any: revenue || expenses,
    isLoading,
  };
}

/** A menüpont kapuja: bármelyik pénzügyi megtekintő jog elég (a lap fülenként kapuz). */
export const FINANCE_NAV_PERMISSIONS: readonly string[] = [
  ...new Set([...FINANCE_PERMISSIONS.revenueView, ...FINANCE_PERMISSIONS.expensesView]),
];
